// Resolves after the browser has painted, so a loading indicator shown just before some heavy,
// blocking work is actually visible while that work runs.
export function nextPaint () {
  return new Promise(resolve => requestAnimationFrame(() => setTimeout(resolve, 0)))
}



// WEBPACK FOOTER //
// ./src/components/shared/nextPaint.js